import React from "react";

import InputBox from "../InputBox";
import TextInput from "../TextInput";

import classes from "./LabelTextInput.module.css";

const LabelTextInput = ({ label, id, optional, className, ...props }) => (
  <InputBox
    className={[classes.inputContainer, className].join(" ")}
    label={label}
    labelFor={id}
    optional={optional}
  >
    <TextInput className={classes.textInput} id={id} {...props} />
  </InputBox>
);

export default LabelTextInput;
